import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {ProcedureInput, ServiceDeliveryDuration, ServiceDeliveryDurationInput} from './service-delivery-duration.model';

export const loadServiceDeliveryDurations = createAction(
  '[ServiceDeliveryDuration/API] Load ServiceDeliveryDurations',
  props<{ serviceDeliveryDurations: ServiceDeliveryDuration[] }>()
);

export const addServiceDeliveryDuration = createAction(
  '[ServiceDeliveryDuration/API] Add ServiceDeliveryDuration',
  props<{ serviceDeliveryDuration: ServiceDeliveryDuration }>()
);

export const upsertServiceDeliveryDuration = createAction(
  '[ServiceDeliveryDuration/API] Upsert ServiceDeliveryDuration',
  props<{ serviceDeliveryDuration: ServiceDeliveryDuration }>()
);

export const addServiceDeliveryDurations = createAction(
  '[ServiceDeliveryDuration/API] Add ServiceDeliveryDurations',
  props<{ serviceDeliveryDurations: ServiceDeliveryDuration[] }>()
);

export const upsertServiceDeliveryDurations = createAction(
  '[ServiceDeliveryDuration/API] Upsert ServiceDeliveryDurations',
  props<{ serviceDeliveryDurations: ServiceDeliveryDuration[] }>()
);

export const updateServiceDeliveryDuration = createAction(
  '[ServiceDeliveryDuration/API] Update ServiceDeliveryDuration',
  props<{ serviceDeliveryDuration: Update<ServiceDeliveryDuration> }>()
);

export const updateServiceDeliveryDurations = createAction(
  '[ServiceDeliveryDuration/API] Update ServiceDeliveryDurations',
  props<{ serviceDeliveryDurations: Update<ServiceDeliveryDuration>[] }>()
);

export const deleteServiceDeliveryDuration = createAction(
  '[ServiceDeliveryDuration/API] Delete ServiceDeliveryDuration',
  props<{ id: string }>()
);

export const deleteServiceDeliveryDurations = createAction(
  '[ServiceDeliveryDuration/API] Delete ServiceDeliveryDurations',
  props<{ ids: string[] }>()
);

export const clearServiceDeliveryDurations = createAction(
  '[ServiceDeliveryDuration/API] Clear ServiceDeliveryDurations'
);

// CUSTOM
export const createServiceDeliveryDuration = createAction(
  '[ServiceDeliveryDuration/API] create ServiceDeliveryDuration',
  props<{ input: ServiceDeliveryDurationInput }>()
);

export const editServiceDeliveryDuration = createAction(
  '[ServiceDeliveryDuration/API] edit ServiceDeliveryDuration',
  props<{ input: ProcedureInput }>()
);

export const removeServiceDeliveryDuration = createAction(
  '[ServiceDeliveryDuration/API] remove ServiceDeliveryDuration',
  props<{ stepUniqueId: string, id: string }>()
);

export const getServiceDeliveryDuration = createAction(
  '[ServiceDeliveryDuration/API] get all ServiceDeliveryDuration',
  props<{ serviceUniqueId: string }>()
);

